exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SearchInput___5BLz9 {\n  flex: 1 1;\n  display: flex;\n  align-items: center;\n}\n\n.Input___15H-Z {\n  flex: 1 1 100px;\n  width: 100px;\n  font-size: var(--font-size-sans-large);\n  outline: none;\n  border: none;\n  background-color: var(--color-background);\n  color: var(--color-text);\n  padding-left: 1.5rem;\n  margin-left: -1rem;\n}\n\n.InputIcon___2jd-q {\n  pointer-events: none;\n  z-index: 2;\n  color: var(--color-dimmer);\n}\n\n.IndexLabel___98Dk_ {\n  color: var(--color-dim);\n  font-size: var(--font-size-sans-normal);\n  white-space: pre;\n}\n\n.LeftVRule___B5avU,\n.RightVRule___1XZ0Q {\n  height: 20px;\n  width: 1px;\n  background-color: var(--color-border);\n}\n.LeftVRule___B5avU {\n  margin: 0 0.25rem 0 0.5rem;\n}\n.RightVRule___1XZ0Q {\n  margin: 0 0.5rem 0 0.25rem;\n}\n", ""]);

// exports
exports.locals = {
	"SearchInput": "SearchInput___5BLz9",
	"Input": "Input___15H-Z",
	"InputIcon": "InputIcon___2jd-q",
	"IndexLabel": "IndexLabel___98Dk_",
	"LeftVRule": "LeftVRule___B5avU",
	"RightVRule": "RightVRule___1XZ0Q"
};